import React, { useEffect, useState } from 'react';
import { Snackbar, SnackbarContent } from '@mui/material';
import useSnackbarStore from '@store/snackbar-store/snackbar.store.ts';
import { CloseIcon } from '@components/icons/svg-icon.tsx';
import { snackbarTypes } from '@models/app-snackbar.model.ts';
import { useTranslation } from 'react-i18next';

const SnackbarComponent = () => {
  const { t } = useTranslation();
  const { snackbarOpen, snackbarMessage, snackbarType, hideSnackbar } =
    useSnackbarStore();
  const [progress, setProgress] = useState(0);

  const { color, icon } = snackbarTypes[snackbarType] || snackbarTypes.success;
  const autoHideDuration = 4000;

  useEffect(() => {
    if (!snackbarOpen) return setProgress(0);

    let progressValue = 0;
    const intervalTime = 60;
    const progressDuration = autoHideDuration;

    const timer = setInterval(() => {
      progressValue += 100 / (progressDuration / intervalTime);
      setProgress(progressValue);

      if (progressValue >= 100) {
        clearInterval(timer);
        setTimeout(hideSnackbar, 500);
      }
    }, intervalTime);

    return () => clearInterval(timer);
  }, [snackbarOpen, hideSnackbar, autoHideDuration]);

  return (
    <Snackbar
      open={snackbarOpen}
      autoHideDuration={autoHideDuration}
      onClose={hideSnackbar}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      sx={{ mt: 10 }}
    >
      <div className="relative w-full">
        <SnackbarContent
          message={
            <div className="flex items-center gap-2">
              <img src={icon} alt="Snackbar Icon" />
              <span className="text-[var(--black)] text-base font-normal">
                {t(snackbarMessage)}
              </span>
            </div>
          }
          className="!flex !items-center !justify-between !border-none !shadow-md !bg-[var(--white)] !py-3 !px-5 !rounded-[4px]"
          action={
            <button
              className="cursor-pointer absolute right-[10px] top-[10px]"
              onClick={hideSnackbar}
              aria-label="close"
            >
              <CloseIcon className="!h-[14px] !w-[14px]" />
            </button>
          }
        />
        <div
          className="absolute bottom-0 left-0 h-[5px] rounded-b-[4px] transition-width duration-[60ms] ease-linear"
          style={{
            width: `${progress}%`,
            backgroundColor: color,
            borderBottom: `2px solid ${color}`
          }}
        />
      </div>
    </Snackbar>
  );
};

export default SnackbarComponent;
